import {
  PreferredAngles,
  type RotationLimits,
  type Bone,
} from '../../lib/skeleton/core';
import {
  ensureBoneProperties,
  ensureRotationLimits,
  getRotationLimitsAxisMode,
  pruneBonePropertiesDefaults,
} from '../../lib/skeleton/rotationLimits';
import type { AxisMode } from './constants';

export function getAxisMode(
  limits: RotationLimits,
  axis: number,
): AxisMode {
  return getRotationLimitsAxisMode(limits, axis);
}

export { ensureBoneProperties, ensureRotationLimits };
export { pruneBonePropertiesDefaults };

export function ensurePreferredAngles(bone: Bone): PreferredAngles {
  const properties = ensureBoneProperties(bone);
  if (!properties.preferredAngles) {
    properties.preferredAngles = new PreferredAngles();
  }
  return properties.preferredAngles;
}

